var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileExportFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C20.4839 13.5 22.5 15.5161 22.5 18C22.5 20.4839 20.4839 22.5 18 22.5C15.5161 22.5 13.5 20.4839 13.5 18C13.5 15.5161 15.5161 13.5 18 13.5ZM17.4189 15.373C16.9677 15.0177 16.3076 15.0356 15.8867 15.4561L14.1494 17.1934C13.7171 17.643 13.7074 18.3645 14.1562 18.8135L15.8867 20.5439C16.1152 20.7722 16.4046 20.8799 16.7002 20.8799C16.9958 20.8798 17.2852 20.7723 17.5137 20.5439L17.5205 20.5361C17.9526 20.0864 17.9626 19.3649 17.5137 18.916L16.5967 18L17.5137 17.084L17.5205 17.0762C17.9526 16.6265 17.9626 15.905 17.5137 15.4561L17.5068 15.4492L17.4189 15.373ZM20.1064 15.4492C19.6568 15.0171 18.9353 15.0073 18.4863 15.4561L18.4795 15.4639C18.0474 15.9136 18.0374 16.6351 18.4863 17.084L19.4014 17.998L18.4775 18.915L18.4697 18.9238C18.0375 19.3735 18.0276 20.095 18.4766 20.5439C18.705 20.7723 18.9944 20.8799 19.29 20.8799C19.5857 20.8799 19.875 20.7723 20.1035 20.5439L21.8408 18.8066C22.2756 18.3543 22.275 17.6538 21.8574 17.2012L21.8506 17.1934L20.1064 15.4492Z",
    fill: "url(#paint0_linear_48458_44668)",
    stroke: "url(#paint1_linear_48458_44668)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.56757C18.2577 2.7402 19.1099 3.24638 19.6572 3.96991C20.2148 4.70723 20.5 5.72931 20.5 7.00018V11.466C19.3102 11.0093 17.9809 10.862 16.5918 11.1398C13.7891 11.7004 11.5608 13.9921 11.0967 16.8185V16.8195C10.8352 18.4284 11.1201 19.9606 11.8076 21.2424L11.9502 21.4953C11.9512 21.4972 11.9519 21.4985 11.9521 21.4992C11.9522 21.499 11.9517 21.4992 11.9512 21.5002H8C6.3453 21.5002 5.24547 21.0293 4.55371 20.2844C3.85594 19.5327 3.50003 18.4232 3.5 17.0002V7.00018C3.5 5.73866 3.77998 4.72289 4.3291 3.98749C4.86837 3.26534 5.70815 2.75754 6.94727 2.57635L6.94824 2.57733L6.9502 2.5871L6.98047 3.59491C7.01864 5.46802 8.59306 7.00018 10.4805 7.00018H13.5C15.4261 7.00018 16.9999 5.42623 17 3.50018V2.56757Z",
    fill: "url(#paint2_linear_48458_44668)",
    stroke: "url(#paint3_linear_48458_44668)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96191 2.5H14.002C14.2756 2.50021 14.502 2.72627 14.502 3V3.5C14.502 4.04373 14.0456 4.49979 13.502 4.5H10.4717C9.96515 4.5 9.54041 4.11749 9.47852 3.62695L9.47168 3.52734L9.46191 3.02051L9.46094 3.0127L9.46777 2.90918C9.50705 2.67542 9.70745 2.5 9.96191 2.5Z",
    fill: "url(#paint4_linear_48458_44668)",
    stroke: "url(#paint5_linear_48458_44668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48458_44668",
    x1: 13.5616,
    y1: 18.034,
    x2: 22.5616,
    y2: 18.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48458_44668",
    x1: 13.5616,
    y1: 18.034,
    x2: 22.5616,
    y2: 18.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48458_44668",
    x1: 4.01096,
    y1: 12.1006,
    x2: 20.211,
    y2: 12.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_48458_44668",
    x1: 4.01096,
    y1: 12.1006,
    x2: 20.211,
    y2: 12.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_48458_44668",
    x1: 9.30021,
    y1: 3.5102,
    x2: 14.7368,
    y2: 3.5102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_48458_44668",
    x1: 9.30021,
    y1: 3.5102,
    x2: 14.7368,
    y2: 3.5102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1968B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DB53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExportFilled);
export default __webpack_public_path__ + "static/media/fileExportFilled.41d7395c023f1a013bdc9795bdfc142e.svg";
export { ForwardRef as ReactComponent };